import React, { useState, useEffect } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { ArrowUp } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

const BackToTop = ({ isSaving = false }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set up scroll event listener when component mounts
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Only show back to top when it's visible AND not saving
  const showBackToTop = isVisible && !isSaving;
  
  return (
    <>
      {/* Saving indicator (independent of back-to-top button) */}
      {isSaving && (
        <div className="saving-indicator">
          <Spinner animation="border" size="sm" />
          <span className="ms-2">{t('common.saving')}</span>
        </div>
      )}
      
      {/* Back to top button (only shown when needed and not saving) */}
      {showBackToTop && (
        <Button
          onClick={scrollToTop}
          variant="primary"
          size="sm"
          className="back-to-top-btn rounded-circle"
        >
          <ArrowUp size={25} />
        </Button>
      )}
    </>
  );
};

export default BackToTop; 